import type { IStorage } from "./storage.constants";
import { STORAGE } from "./storage.constants";
import { postJSON } from "./apiUtils";
import { GetLatestDLPPoliciesResponse } from "@whatslly/types/integrations/DlpPoliciesRequest";
import { DLPSettings } from "@whatslly/types/dlp/DLPSettings";

export class UpdateDLPPoliciesService {
  async checkLastUpdate(storage: IStorage, fetchMethod: any, notifyBlockMessaging: () => Promise<void>) {
    const userLastDLPPoliciesUpdate = await storage.get(STORAGE.USER_LAST_DLP_POLICIES_UPDATE);
    const { etoken, whatsllyPod } = await storage.get([STORAGE.ETOKEN_KEY, STORAGE.POD_KEY]);
    if (!etoken || etoken === "false") {
      return;
    }
    try {
      const response = await postJSON({
        urlSuffix: "/integrations/dlp/get-latest-policies",
        pod: whatsllyPod,
        body: JSON.stringify({
          userLastDLPPoliciesUpdate,
        }),
        etoken,
        fetchMethod,
      });
      const body: GetLatestDLPPoliciesResponse = await response.json();
      if (!body.success) return;
      this.updatePolicies(storage, body.dlpSettings, notifyBlockMessaging);
    } catch {
      return;
    }
  }

  async updatePolicies(storage: IStorage, dlpSettings: DLPSettings, notifyBlockMessaging: () => Promise<void>) {
    await storage.set(STORAGE.DLP_SETTINGS, dlpSettings);
    await storage.set(STORAGE.USER_LAST_DLP_POLICIES_UPDATE, Date.now());
    await notifyBlockMessaging();
  }

  async removeStorageLastDLPPoliciesUpdate(storage: IStorage) {
    await storage.remove(STORAGE.USER_LAST_DLP_POLICIES_UPDATE);
  }

  async updateStorageLastDLPPoliciesUpdate(storage: IStorage) {
    await storage.set(STORAGE.USER_LAST_DLP_POLICIES_UPDATE, String(Date.now()) as unknown as number);
  }
}
export const updateDLPPoliciesService = new UpdateDLPPoliciesService();
